<template>
    <!-- 右边主体[[ -->
    <div class="g-content g-autofixheight">
        <!-- 团队管理【【 -->
        <div class="team-manage">
            <div class="g-tab">
                <a href="javascript:;" v-for="(item,index) in tabList" :key="index" @click="changeTab(index)">                            
                    <div class="g-tab-item" :class="{'g-tab-item-active': index == curTab}">{{item.name}}</div>
                </a>
            </div>
            <div v-show="curTab == 0">
                <div class="subheader">
                    <div class="tag-group">
                        <!-- 点击显示左边隐藏内容 start -->
                        <i class="ico ico-arrow-left" @click="swiperPrev" v-show="teamItem.length != 0"></i>
                        <!-- 左侧按钮 -->
                        <div class="swiper-container" id="swiper-tab">
                            <div class="swiper-wrapper">
                                <div class="swiper-slide" v-for="(item,index) in teamItem" :key="item.id">
                                    <a href="javascript:;" class="tag" :class="{'tag-selected': index == curSwiper}" @click="changeSwiper(index,item)"><span class="tab-name f-hide-col-1">{{item.authorTeamName}}</span><span class="mount">（{{item&&item.memberCount?item.memberCount: 0}}）</span></a>
                                </div>
                            </div>
                        </div>
                        <!-- 右侧按钮 -->
                        <i class="ico ico-arrow-right" @click="swiperNext" v-show="teamItem.length != 0"></i>
                        <!-- 点击显示是否创建团队弹窗 start -->
                        <a href="javascript:;" class="g-btn create-team-btn" @click="showCreateTeam">创建团队</a>
                        <!-- 点击显示是否创建团队弹窗 end -->
                    </div>
                </div>
                <div class="search-item" v-show="teamItem.length != 0">
                    <div class="search-bar">
                        <input type="text" class="search-input" v-model.trim="params.qq" placeholder="请输入要搜索的团员QQ号">
                        <div class="search-btn" @click="getTeamMember">
                            <i class="ico ico-search"></i>
                            <i class="ico ico-search-active"></i>
                        </div>
                    </div>
                    <a href="javascript:;" class="g-btn invite" @click="inviteMember">继续邀请</a>
                    <span class="tips">{{teamStatus}}</span>
                </div>
                <div class="team-list create-team">
                    <div class="team-item" v-for="item in teamMember" :key="item.teamId">
                        <div class="left-side">
                            <div class="title f-hide-col-1">{{item.userName}}</div>
                            <div class="msg">
                                <p class="msg-name f-inlineblock-top">QQ:</p>
                                <p class="msg-text f-inlineblock-top f-hide-col-1">{{item.qq}}</p>
                            </div>
                            <div class="msg">
                                <p class="msg-name f-inlineblock-top">微信:</p>
                                <p class="msg-text f-inlineblock-top f-hide-col-1">{{item.wxName ? item.wxName : '-'}}</p>
                            </div>
                        </div>
                        <div class="right-side">
                            <div class="state" :class="item.userStatus == 10 ? 'no' : 'yes'" v-text="getMemberStatus(item)"></div>
                            <!-- 点击显示是否删除中断弹窗 start -->
                            <div class="icon-btn" @click="showDelMember(item)">
                                <i class="ico ico-trash"></i>
                                <i class="ico ico-trash-open"></i>
                            </div>
                            <!-- 点击显示是否删除中断弹窗 end -->
                        </div>
                    </div>                    
                </div>
            </div>
            <div v-show="curTab == 1">
                <div class="team-list join-team">
                    <div class="team-item" v-for="item in joinTeam" :key="item.id">
                        <div class="left-side">
                            <div class="title f-hide-col-1">
                                <span class="join-team-title f-hide-col-1" :title="item.authorTeamName">{{item.authorTeamName}}</span>
                                <div class="mount">（{{item&&item.memberCount?item.memberCount: 0}}人）</div>
                            </div>
                            <div class="msg">
                                <p class="msg-name f-inlineblock-top">邀请时间:</p>
                                <p class="msg-text f-inlineblock-top f-hide-col-1" v-text="formatInvitedTime(item.invitedTime)"></p>
                            </div>
                            <div class="msg">
                                <p class="msg-name f-inlineblock-top">团长昵称:</p>
                                <p class="msg-text f-inlineblock-top f-hide-col-1" :title="item.leaderName">{{item.leaderName}}</p>
                            </div>
                            <div class="msg">
                                <p class="msg-name f-inlineblock-top">团长 QQ:</p>
                                <p class="msg-text f-inlineblock-top f-hide-col-1">{{item.leaderQQ}}</p>
                            </div>
                        </div>
                        <div class="right-side" v-show="item.userStatus == 10">
                            <div class="state no">待确认</div>
                            <a href="javascript:;" class="g-btn" @click="resolveJoin(item)">同意</a>
                            <a href="javascript:;" class="g-btn" @click="rejectJoin(item)">拒绝</a>
                        </div>
                        <div class="right-side" v-show="item.userStatus == 20">
                            <div class="state yes">已同意</div>
                        </div>
                        <div class="right-side" v-show="item.userStatus == 30">
                            <div class="state yes">已拒绝</div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- 分页需要达到7行也就是21个的时候才会有分页，不到21个分页隐藏 -->
            <pagination v-show="curTab == 0"
                :total="count"
                :page-size="params.pageSize" 
                @change="pageChange"
                ref="pager">
            </pagination>
            <!-- <pagination
                :total="count2"
                :page-size="pageSize" 
                @change="pageChange2"
                ref="pager2">
            </pagination> -->
        </div>
        <!-- 团队管理】】 -->
        <!-- 删除成员弹窗start -->
        <div class="popup-con interrupt-popup" v-show="isShowDelMember">
            <div class="popup-close js-close-channel" @click="isShowDelMember = false"><i class="ico ico-close"></i></div>
            <h5 class="popup-title">删除团员</h5>
            <!-- 中间内容需要给出上下左右的margin或padding -->
            <div class="interrupt-popup-con">
                <div class="popup-text">
                    删除团员可能会改变团队的状态，<br>
                    是否删除该团员?
                </div>
                <div class="team-item">
                    <div class="left-side">
                        <div class="title f-hide-col-1">{{delItem.userName}}</div>
                        <div class="msg">
                            <p class="msg-name f-inlineblock-top">QQ:</p>
                            <p class="msg-text f-inlineblock-top f-hide-col-1">{{delItem.qq}}</p>
                        </div>
                        <div class="msg">
                            <p class="msg-name f-inlineblock-top">微信:</p>
                            <p class="msg-text f-inlineblock-top f-hide-col-1">{{delItem.wxName ? delItem.wxName : '-'}}</p>
                        </div>
                    </div>
                    <div class="right-side">
                        <div class="state no f-inlineblock-middle" :class="delItem.userStatus == 10 ? 'no' : 'yes'" v-text="getMemberStatus(delItem)"></div>
                    </div>
                </div>
            </div>
            <div class="g-bottom-btn">
                <a class="button popup-btn-quit" href="javascript:;" @click="delMember">删除</a>
                <a class="button popup-btn-cancel" href="javascript:;" @click="isShowDelMember = false">取消</a>
            </div>
        </div>
        <!-- 删除成员弹窗end -->

        <!-- 团队弹窗[[ -->
        <div class="popup-con team-popup" v-show="isShowCreateTeam">
            <div class="popup-close" @click="isShowCreateTeam = false"><i class="ico ico-close"></i></div>
            <h5 class="popup-title">邀请团员</h5>
            <div class="team-form">
                <div class="team-item">
                    <div class="label">团队名称</div>
                    <div class="val">
                        <input class="team-name" type="text" placeholder="长度在2-20个字符之间" v-model.trim="createTeamParams.name" :disabled="disableTeamName">
                    </div>
                </div>
                <div class="team-item">
                    <div class="label">团队成员</div>
                    <!-- 点击js-team-add(添加成员)即新增整个team-item的内容 -->
                    <a href="javascript:;" class="g-btn add js-team-add" @click="changeItemLength(1)">添加成员</a>
                </div>
                <div class="team-tip">注:团队成员需要登录过TGL平台</div>
                <div class="team-selector g-scrollbar">
                    <div class="team-item" v-for="(item,index) in createItemLength" :key="index">
                        <div class="label">成员账号</div>
                        <div class="val">
                            <input type="text" v-model.trim="createTeamParams.qq[index]" placeholder="请输入成员QQ号码">
                            <!-- 点击 js-team-delete的话整个team-item内容删除掉-->
                            <div class="close-btn" @click="changeItemLength(-1,index)">
                                <i class="ico ico-close-fillet js-team-delete"></i>
                                <i class="ico ico-close-fillall"></i>
                            </div>
                        </div>
                    </div>
                    
                </div>
            </div>
            <div class="footer-btn g-bottom-btn">
                <a class="g-btn popup-btn-confirm" href="javascript:;" @click="createTeam">确定</a>
                <a class="g-btn" href="javascript:;" @click="isShowCreateTeam = false">取消</a>
            </div>
        </div>
        <!-- 团队弹窗]] -->
    </div>
    <!-- 右边主体]] -->
</template>
<style lang="scss" scoped>
    @import '~Assets/vendor/swiper/swiper-3.2.7.min.css';
    @import '~Assets/sass/pages/v4/manage/team.scss';
    .tab-name{
        display: inline-block;
        vertical-align: middle;
        max-width: 100px;
    }
    .swiper-container{
        width: 700px;
        display: inline-block;
        vertical-align: middle;
        .swiper-slide{
            width: auto;
        }
    }
    .team-name{
        background-color: #fff;
    }
    .join-team-title{
        width: 85px;
        display: inline-block;
        vertical-align: middle;
    }
    .team-tip{
        color:#bfbfbf;
        font-size:12px;
    }
</style>
<script>
import Swiper from 'Assets/vendor/swiper/swiper-3.2.7.min.js';
import pagination from 'Components/v4/pagination/pagination_v4';

import {
    TeamOwned, TeamJoined, TeamMember, TeamCreate, TeamMemberInvite, TeamMemberDelete, TeamInviteAgree, TeamInviteReject
} from 'Services/getData.js';
export default {
    data() {
        return {
            teamItem: [], //创建的团队
            teamMember: '',
            teamId: '',
            curTeam: {
                memberCount: 0
            },
            teamStatus: '',
            delItem: '',
            joinTeam: [], //加入的团队
            mySwiper: '',
            tabList: [
                {
                    name: '我创建的团队',
                    val: 0
                },
                {
                    name: '我加入的团队',
                    val: 1
                }
            ],
            curTab: 0,
            curSwiper: 0,
            // pageSize: 1, // 展示条数
            // count : 0, //总记录数
            params: {
                pageSize: 21,
                page: 1,
                teamId: '',
                qq: ''
            },
            isShowCreateTeam: false,
            createTeamParams: {
                // 创建团队字段
                name: '',
                qq: []
            },
            createItemLength: 1,
            isShowDelMember: false,
            disableTeamName: false
        }
    },
    computed: {
        count(){
            return this.curTeam.memberCount;

        }
    },
    components: {
        pagination
    },
    mounted(){
        this.getOwnTeam();
        this.getJoinTeam();
    },
    methods: {
        formatInvitedTime(date){
            return this.$common.formatDate(date, '-');
        },
        async resolveJoin(item){
            let res = await TeamInviteAgree({
                'teamId': item.id
            });
            if(res.data.code == 0){
                this.getJoinTeam();
            }
        },
        async rejectJoin(item){
            let res = await TeamInviteReject({
                'teamId': item.id
            });
            if(res.data.code == 0){
                this.getJoinTeam();
            }
            console.log(res);
        },
        async inviteMember(){
            this.showCreateTeam(1);
        },
        showDelMember(item){
            this.delItem = item;
            this.isShowDelMember = true;
        },
        async delMember(){
            let params = {};
            // console.log(this.delItem)
            params.teamId = this.curTeam.id;
            params.qq = this.delItem.qq;
            let res = await TeamMemberDelete(params);
            if(res.data.code == 0){
                this.$alert('删除成功');
                this.isShowDelMember = false;
                this.getOwnTeam();
                this.getTeamMember();
            }
        },
        getMemberStatus(item){
            switch(item.userStatus){
            case 10:
                return '待确认';
                break;
            case 20:
                return '已同意';
                break;
            case 30:
                return '已拒绝';
                break;
            }
        },
        getTeamStatus(item){
            switch(item.teamStatus){
            case 10:
                this.teamStatus = '申请中(暂未成团)';
                break;
            case 20:
                this.teamStatus = '正常(已成团)';
                break;
            case 30:
                this.teamStatus = '创建失败';
                break;
            }
        },
        changeItemLength(status, index){
            if(status == 1){
                ++this.createItemLength;
            }else{
                this.createTeamParams.qq.splice(index, 1)
                --this.createItemLength;
            }
        },
        showCreateTeam(type){
            this.createItemLength = 1;
            this.createTeamParams.qq = [];
            this.createTeamParams.name = '';
            if(type == 1){
                this.disableTeamName = true;
                this.createTeamParams.name = this.curTeam.authorTeamName;
            }else{
                this.disableTeamName = false;
                this.createTeamParams.name = '';
            }
            this.isShowCreateTeam = true;

        },
        async createTeam(){
            if(this.createTeamParams.name.length < 2 || this.createTeamParams.name.length > 20){
                this.$alert('团队名称长度在2-20个字符之间')
                return false;
            }
            if(!this.disableTeamName){
                // 创建
                let params = {};
                params.name = this.createTeamParams.name;
                params.qq = this.createTeamParams.qq.filter((e) => {return e}).join(',');
                let res = await TeamCreate(params);
                if(res.data.code == 0){
                    this.$alert('创建成功');
                    this.isShowCreateTeam = false;
                    this.getOwnTeam();
                }
            }else{
                // 继续邀请
                let inviteParams = {};
                inviteParams.teamId = this.curTeam.id;
                inviteParams.qq = this.createTeamParams.qq.filter((e) => {return e}).join(',');
                let inviteRes = await TeamMemberInvite(inviteParams);
                console.log(inviteRes)
                if(inviteRes.data.code == 0){
                    this.$alert('成功');
                    this.isShowCreateTeam = false;
                    this.getOwnTeam();
                    this.getTeamMember();
                }
            }

        },
        async getOwnTeam(){
            // 获取团队列表
            let res = await TeamOwned();
            this.teamItem = res.data.data;
            this.initSwiper();
        },
        async getJoinTeam(){
            TeamJoined().then( (res) => {
                this.joinTeam = res.data.data;
            })
        },
        changeSwiper(index, item){
            this.curSwiper = index;
            this.curTeam = item;
            this.$refs.pager.reload();
            this.params.page = 1;
            this.getTeamMember();
            this.getTeamStatus(item);
        },
        changeTab(index){
            this.curTab = index;
        },
        initSwiper(){
            this.$nextTick( () => {
                this.mySwiper = new Swiper('#swiper-tab', {
                    paginationClickable: true,
                    slidesPerView: 'auto',
                    initialSlide: 0,
                    slideToClickedSlide: true,
                    // centeredSlides : true,
                    onTransitionEnd: function(swiper){
                        if(swiper.progress == 1){
                            swiper.activeIndex = swiper.slides.length-1
                        }
                    }
                })
                if(this.teamItem && this.teamItem.length>0){
                    this.curTeam = this.teamItem[0];
                    this.getTeamStatus(this.teamItem[0]);
                    this.getTeamMember();
                }
            })
        },
        swiperPrev(){
            this.mySwiper.slidePrev();
        },
        swiperNext(){
            this.mySwiper.slideNext();
        },
        async getTeamMember(){
            this.params.teamId = this.curTeam.id
            let res = await TeamMember(this.params);
            this.teamMember = res.data.data;
            console.log(res)
        },
        pageChange (param) {
            this.params.page = param.pageIndex;
            this.getTeamMember();
        }
        // pageChange2 (param) {
        //     // this.params2.pageIndex = param.pageIndex-1;
        //     this.getJoinTeam();
        // },
    }
}
</script>